import DynamicAddDel from './DynamicAddDel';

export default DynamicAddDel;
